import React from "react";
import { Routes as RouterRoutes, Route, Navigate } from "react-router-dom";
import {
  AUTHENTICATED_ADMIN_ENTRY,
  AUTHENTICATED_ENTRY,
  UNCOMPLETED_AGENCY_PROFILE_PATH,
  UNCOMPLETED_CANDIDATE_PROFILE_PATH,
} from "configs/AppConfig";
import {
  protectedRoutes,
  candidateRoutes,
  publicRoutes,
  staffRoutes,
} from "configs/RoutesConfig";
import ProtectedRoute from "./ProtectedRoute";
import PublicRoute from "./PublicRoute";
import AppRoute from "./AppRoute";
import { USER_INFO } from "constants/AuthConstant";
import { useDispatch, useSelector } from "react-redux";
import { setUserInfo } from "store/slices/userSlice";
import { AESEncrypt } from "utils/encryption";
const Routes = () => {
  const dispatch = useDispatch();
  const { isCompletedProfile, candidateId, agencyId, role } = useSelector(
    (state) => state.auth
  );
  const loggedInRole = JSON.parse(localStorage.getItem(USER_INFO))?.role ?? "";
  dispatch(setUserInfo(loggedInRole));

  const protectedRoutesBasedOnRole = protectedRoutes.filter((route) => {
    if (route.roles && route.roles.length > 0) {
      return route.roles.some((role) => loggedInRole && loggedInRole === role);
    }

    return true;
  });

  const navigateTo = () => {
    if (!isCompletedProfile) {
      if (candidateId) {
        return UNCOMPLETED_CANDIDATE_PROFILE_PATH + AESEncrypt(candidateId);
      } else if (agencyId) {
        return UNCOMPLETED_AGENCY_PROFILE_PATH + AESEncrypt(agencyId);
      } else {
        return AUTHENTICATED_ENTRY;
      }
    } else {
      if (role === "Admin") {
        return AUTHENTICATED_ADMIN_ENTRY;
      }
      return AUTHENTICATED_ENTRY;
    }
  };
  return (
    <RouterRoutes>
      <Route path="/" element={<ProtectedRoute />}>
        <Route path="/" element={<Navigate replace to={navigateTo()} />} />
        {protectedRoutesBasedOnRole.map((route, index) => {
          return (
            <Route
              key={route.key + index}
              path={route.path}
              element={
                <AppRoute
                  routeKey={route.key}
                  component={route.component}
                  {...route.meta}
                />
              }
            />
          );
        })}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
      <Route path="/" element={<PublicRoute />}>
        {publicRoutes.map((route) => {
          return (
            <Route
              key={route.path}
              path={route.path}
              element={
                <AppRoute
                  routeKey={route.key}
                  component={route.component}
                  {...route.meta}
                />
              }
            />
          );
        })}
      </Route>
    </RouterRoutes>
  );
};

export default Routes;
